export enum EventTypes {
  TriggerCameraAccess = 'triggerCameraAccess',
  VisitPlus = 'visitPlus',
}

export interface BaseEvent {
  type: EventTypes;
}
